import ng from 'angular';

export interface IConfirmacaoExclusaoTextos {
    titulo: string;
    descricao?: string;
    textoConfirmacao?: string;
    botoes: {
        fechar: string;
        confirmar: string;
    };
}

export class ConfirmacaoExclusaoModalController implements ng.IController {

    static $inject = [
        'textos',
        '$uibModalInstance'
    ];

    constructor(
        public textos: IConfirmacaoExclusaoTextos,
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService
    ) {}

    public confirmar(): void {
        this.$uibModalInstance.close(true);
    }

    public cancelar(): void {
        this.$uibModalInstance.dismiss('cancelar');
    }
}
